import React, { useState, useEffect, useLayoutEffect } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./map.scss";
import Pin from "../pin/Pin";
import FixMapSize from "./FixmapSize";


function Map({ items }) {
  // items first row should have longitud and latitude


// const DEFAULT_CENTER = [28.526677, 76.6179781];
const DEFAULT_CENTER = [28.626677, 77.2];

function getValidCoords(lat, lng) {
  const latitude = Number(lat);
  const longitude = Number(lng);

  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    latitude === 0 ||
    longitude === 0
  ) {
    return DEFAULT_CENTER;
  }

  return [latitude, longitude];
}




  if (!Array.isArray(items)) {
    console.error("Items prop should be an array");
    return null;
  }

  const center =
items.length === 1
    ? getValidCoords(items[0].latitude, items[0].longitude)
    : DEFAULT_CENTER;
      const [mounted, setMounted] = useState(false); // ✅ ensures client-only render
  
      // const [unmountMap, setUnmountMap] = useState(false);

  // prevent map re-initialization
  // useLayoutEffect(() => {
  //   setUnmountMap(false);
  //   return () => {
  //     setUnmountMap(true);
  //   };
  // }, []);



  // ✅ only render map after client mount
  useEffect(() => {
    setMounted(true);
  }, []);

  // if (!mounted || unmountMap) {
  if (!mounted) {

    return <div style={{ height: "400px", background: "#eee" }}>Loading map...</div>;
  }

  return (
    <MapContainer
      center={center}
      zoom={9}
      scrollWheelZoom={false}
      className="map"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FixMapSize/>
      {items.map((item) => (
        <Pin item={item} key={item?.id} />
      ))}
    </MapContainer>
  );
}

export default Map;
